import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { IThunkRejectValue, RootState } from "../../../types";
import { getExtractErrors } from "../../../apis";
import { CustomErrorToast } from "../../../components/general/Toast";
import { getAiAppApi } from "../../../apis/ai-deploysAPI";
import { AiApp, AiAppState } from "../../../types/ai";
// import { dummyApps } from "./appsSlice";

const initialState: AiAppState = {
  app: null,
  appLoading: false,
  showSynchronisationModal: false,
};

export const getAiAppAsync = createAsyncThunk<
  { app: AiApp },
  { id: string; withoutLoading?: boolean },
  IThunkRejectValue
>(
  "app",
  async (
    { id, withoutLoading = false },
    { rejectWithValue, fulfillWithValue, dispatch, requestId }
  ) => {
    try {
      dispatch(
        getAiAppAsync.pending(requestId, {
          id,
          withoutLoading,
        })
      );
      const response = await getAiAppApi(id);
      const app = response.data.Result;
      return fulfillWithValue({ app });
    } catch (e) {
      return rejectWithValue({ message: getExtractErrors(e) });
    }
  }
);

export const aiAppSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    handleClearAiAppSlice: (state) => {
      state.app = initialState.app;
      state.appLoading = initialState.appLoading;
    },
    handleSynchronisation: (
      state,
      { payload: { status } }: PayloadAction<{ status: boolean }>
    ) => {
      state.showSynchronisationModal = status;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAiAppAsync.pending, (state, action) => {
        if (!action.meta.arg.withoutLoading) state.appLoading = true;
      })
      .addCase(getAiAppAsync.fulfilled, (state, action) => {
        const { app } = action.payload;
        state.app = app;
        state.appLoading = false;
      })
      .addCase(getAiAppAsync.rejected, (state, { payload }) => {
        state.appLoading = false;
        // state.app = dummyApps[2]; //TODO
        if (payload?.message)
          toast.error(() => CustomErrorToast(payload?.message));
      });
  },
});

export const selectAiApp = (state: RootState) => state.aiApp.app;
export const selectAiAppLoading = (state: RootState) => state.aiApp.appLoading;
export const selectShowSynchronisationModal = (state: RootState) =>
  state.aiApp.showSynchronisationModal;

export const { handleClearAiAppSlice, handleSynchronisation } =
  aiAppSlice.actions;
export default aiAppSlice.reducer;
